import { ProfileService } from './../../../../services/profile/profile.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import { environment } from 'src/environments/environment';
import { Consumable } from 'src/app/util/interfaces/stockConsumables';
import * as XLSX from 'xlsx';

@Injectable({
	providedIn: 'root',
})
export class CmdbStockReportPageService {
	private getFormOptionsUrl = environment.baseApiUrl + 'stock/report/params/{qryString}';
	private getReportUrl = environment.baseApiUrl + 'stock/report/{qryName}?{qryString}';
	private getReport = environment.baseApiUrl + 'stock/report/{qryName}';
	private getNewItemsByDate = environment.baseApiUrl + 'stock/report/{qryString}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getReportData(dateString: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getReportUrl = this.getNewItemsByDate.replace('{qryString}', dateString);
		return this.http.get(getReportUrl, { headers: headers });
	}

	getFormOptions(formOption: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		if (formOption === 'consumables') {
			formOption = this.getFormOptionsUrl.replace('{qryString}', formOption);
		}

		if (formOption === 'newItems') {
			formOption = this.getFormOptionsUrl.replace('{qryString}', formOption);
		}

		if (formOption === 'stockLoan') {
			formOption = this.getFormOptionsUrl.replace('{qryString}', formOption);
		}

		return this.http.get<JSON[]>(formOption, { headers: headers }).pipe(
			map((formOptionsRes) => {
				const newFormOptionsArray: genericFormInterface[] = [];
				formOptionsRes.forEach((formOption: any) => {
					const newFormOption: genericFormInterface = {
						//"id" : formOption.id,
						inputType: formOption.type_param,
						//"reportName" : "",
						name: formOption.name_param,
						label: formOption.label_param,
						//"regex" : formOption.regex,
						selected: false,
						items: [],
						values: [''],
					};

					if (formOption.items && formOption.items.length > 0) {
						formOption.items.forEach((item: any) => {
							const newItem: genericFormInterface['items'][number] = {
								label: item.label_item,
								name: item.name_item,
								values: [item.value_item],
							};

							newFormOption.items.push(newItem);
						});
					}

					newFormOptionsArray.push(newFormOption);
				});

				return newFormOptionsArray;
			})
		);
	}

	createReport(spreadsheetView: string, reportParameters: genericFormInterface[]) {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		if (reportParameters.length === 0) {
			return this.http.get<Consumable[]>(this.getReport.replace('{qryName}', spreadsheetView), { headers: headers });
		}
		let query = '';

		for (const [index, reportForm] of reportParameters.entries()) {
			let concatStock = reportForm.name;

			for (const value of reportForm.values) {
				concatStock = concatStock.concat('=' + value);
				if (index !== reportParameters.length - 1) {
					concatStock += '&';
				}
			}
			query += concatStock;
		}

		const reportUrl = this.getReportUrl.replace('{qryString}', query).replace('{qryName}', spreadsheetView);

		return this.http.get<Consumable[]>(reportUrl, { headers: headers });
	}

	exportExcel(): void {
		const element = document.querySelector('#excel-table');
		const date = new Date();
		const dateFormatted = date.getMonth() + 1 + '-' + date.getDate() + '-' + date.getFullYear();
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { dateNF: 'mm/dd/yyyy', cellDates: true, raw: true });
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, 'ExportStock_' + dateFormatted + '.xlsx');
	}
}
